export const CALENDAR_VIEWS: { [key: string]: { name: string; code: string }[] } = {
  'dashboard': [
    { name: 'Mes', code: 'dayGridMonth' },
    { name: 'Semana', code: 'timeGridWeek', },
    { name: 'Día', code: 'timeGridDay' }
  ],
  'tasks': [
    { name: 'Mes', code: 'dayGridMonth', },
    { name: 'Semana', code: 'dayGridWeek' },
    { name: 'Día', code: 'timeGridDay', }
  ]
};

export type CalendarEventTypeGroupKey = 'common' | 'residential' | 'commercial';

export interface CalendarEventTypeGroupDefinition {
  key: CalendarEventTypeGroupKey;
  label: string;
  eventNames: string[];
}

export const CALENDAR_EVENT_TYPE_GROUPS: CalendarEventTypeGroupDefinition[] = [
  {
    key: 'common',
    label: 'Común',
    eventNames: [
      'OPERATIONS_START',
      'GAS_SUPPLY',
      'TANK_LEVEL_READING',
      'CONSUMPTION_METER_READING',
      'RECEIPT_DELIVERY',
      'PREVENTIVE_MAINTENANCE',
      'CORRECTIVE_MAINTENANCE',
      'SUPPLY_CUT',
      'RECONNECTION',
      'CLIENT_DEACTIVATION',
      'CLIENT_REACTIVATION'
    ]
  },
  {
    key: 'residential',
    label: 'Habitacional',
    eventNames: [
      'GENERATE_RESIDENTIAL_RECEIPT',
      'RESIDENTIAL_PAYMENT_DEADLINE',
      'GENERATE_RESIDENTIAL_INVOICE',
      'GENERATE_GENERAL_PUBLIC_INVOICE'
    ]
  },
  {
    key: 'commercial',
    label: 'Comercial',
    eventNames: [
      'GENERATE_COMMERCIAL_RECEIPT',
      'GENERATE_COMMERCIAL_INVOICE',
      'GENERATE_GROUPED_COMMERCIAL_INVOICES',
      'COMMERCIAL_PAYMENT_DEADLINE'
    ]
  }
];

export const CALENDAR_EVENT_TYPE_GROUP_KEYS_BY_SETTLEMENT_TYPE: Record<number, CalendarEventTypeGroupKey[]> = {
  0: ['common', 'residential'],
  1: ['common', 'commercial'],
  2: ['common', 'residential', 'commercial']
};
